import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // useParams 가져오기
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase"; // Firestore 초기화

import Loading from '../Loading';

import styleClasses from './css/PositionSkill.module.scss';

// 레벨에 따른 퍼센티지 매핑
const levelToPercentage = {
  Beginner: 25,
  Intermediate: 50,
  Advanced: 75,
  Expert: 100,
};

const PositionSkill = () => {
  const { id: musicianId }        = useParams(); // URL에서 musicianId 가져오기
  const [positions, setPositions] = useState([]); // 포지션 데이터 상태
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태
  
  // Firestore에서 데이터 가져오기
  const fetchPositions = async (musicianId) => {
    try {
      // 1. positions 컬렉션의 문서 이름 가져오기
      const positionsRef = collection(db, "musicians", musicianId, "positions");
      const positionsSnapshot = await getDocs(positionsRef);

      const positionNames = positionsSnapshot.docs.map((doc) => doc.id); // 문서 ID 리스트

      const fetchedPositions = [];

      // 2. 각 position의 skills 가져오기
      for (const position of positionNames) {
        const skillsRef = collection(
          db,
          "musicians",
          musicianId,
          "positions",
          position,
          "skills"
        );
        const skillsSnapshot = await getDocs(skillsRef);

        const skills = skillsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        fetchedPositions.push({
          position: position.charAt(0).toUpperCase() + position.slice(1), // 첫 글자 대문자화
          skills,
        });
      }
      
      setPositions(fetchedPositions);
    } catch (error) {
      console.error("Error fetching positions:", error);
    } finally {
      setIsLoading(false); // 로딩 완료
    }
  };

  useEffect(() => {
    if (musicianId) {
      fetchPositions(musicianId); // 뮤지션 ID로 데이터 가져오기
    }
  }, [musicianId]);

  return (
    isLoading ? (
      <Loading /> // 로딩 상태 처리
    ) : positions.length > 0 ? ( // 포지션 데이터가 있는 경우
      <div className={styleClasses.positionSkill}>
        <div className={styleClasses.gridContainer}>
          {positions.map((position) => (
            <div key={position.position} className={styleClasses.positionSection}>
              <div className={styleClasses.skillsGrid}>
                <h3 className={styleClasses.positionTitle}>{position.position}</h3>
                {position.skills.map((skill) => (
                  <a
                    key={skill.id}
                    href={skill.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styleClasses.skillCard}
                  >
                    <h4 className={styleClasses.skillName}>{skill.name}</h4>
                    <img
                      src={skill.icon}
                      alt={skill.name}
                      className={styleClasses.skillIcon}
                    />
                    <span className={styleClasses.playIcon}>▶</span> {/* 재생 아이콘 */}
                    {skill.description && (
                      <p className={styleClasses.skillDescription}>{skill.description}</p>
                    )}
                    <div className={styleClasses.skillLevelBar}>
                      <div
                        className={styleClasses.skillBarFill}
                        style={{
                          width: `${levelToPercentage[skill.level]}%`,
                        }}
                      ></div>
                    </div>
                    <span className={styleClasses.skillLevel}>
                      {skill.level} ({levelToPercentage[skill.level]}%)
                    </span>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <p className={styleClasses.noData}>No data available yet. :(</p> // 포지션 데이터가 없는 경우 메시지
    )
  );  
};

export default PositionSkill;
